module.exports = require("./fr-CI.js");